import * as types from "@/store/constants/index_types";
export default {
  [types.UPDATE_MASTER_USER_ID](state: any, payLoad: any) {
    state.master_user_id = payLoad;
  },
  [types.UPDATE_CURRENT_USER_ID](state: any, payLoad: any) {
    state.current_user_id = payLoad;
  },
  [types.UPDATE_CURRENT_EARN_COINS_USER_ID](state: any, payLoad: any) {
    state.current_earn_coins_user_id = payLoad;
  }
};
